import { render, staticRenderFns } from "./loginborrow.vue?vue&type=template&id=e4be96ea&scoped=true&"
import script from "./loginborrow.vue?vue&type=script&lang=js&"
export * from "./loginborrow.vue?vue&type=script&lang=js&"
import style0 from "./loginborrow.vue?vue&type=style&index=0&id=e4be96ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4be96ea",
  null
  
)

export default component.exports